<template>
  <div class="select-input">

    <div class="">
      <label v-if="!!label">
        <img v-if="label === 'Beds'" src="@/assets/styles/frontend-library/images/bed.svg"/>
        <img v-if="label === 'Baths'" src="@/assets/styles/frontend-library/images/bath.svg"/>
        <img v-if="label === 'Cars'" src="@/assets/styles/frontend-library/images/car.svg"/>
        {{ label + ( isMandatory ? ' *' : '') }}
      </label>

      <select-list
        class="ut-mr-0 ut-block"
        classes="ga-event"
        :gacategory="gacategory"
        :gaeventlabel="label"
        :options="formattedOptions"
        :value="this.default"
        @input="onSelect"
      />
    </div>

    <span v-if="isError" id="error-message" class="error inline">
      {{ errorMsg }}
    </span>

  </div>
</template>

<script>

import SelectList from '@/components/Forms/SelectList.vue';

export default {
  name: 'SelectInput',
  components: {
    SelectList,
  },
  props: {
    label: {
      required: true,
    },
    isMandatory: {
      default: false,
    },
    options: {
      required: true,
    },
    includeDefault: {
      default: true,
    },
    default: {
      default: '',
    },
    gacategory: {
      default: null,
    },
    gaeventlabel: {
      default: null,
    },
  },
  computed: {
    isError() {
      return this.errorMsg !== '';
    },
    isValueSelected() {
      return !!this.value
        && this.value.length > 0;
    },
    index() {
      if (this.value !== '') {
        for (let i = 0; i < this.options.length; i += 1) {
          if (`${this.options[i].value}` === `${this.value}`) {
            return i + 1;
          }
        }
      }
      return -1;
    },
    valuesObject() {
      return {
        error: this.isError,
        label: this.label,
        value: this.value,
        index: this.index,
      };
    },
  },
  created() {
    this.$parent.$on('validate-fields', this.validate);
    this.$parent.$on(`${this.label}-set-value`, this.setValue);
    this.value = this.default;
    this.formatOptions();
  },
  data() {
    return {
      value: '',
      errorMsg: '',
      formattedOptions: [],
    };
  },
  methods: {
    validate() {
      this.errorMsg = '';
      if (this.isMandatory && !this.isValueSelected) {
        this.errorMsg = 'Please select a value from the dropdown.';
      }

      this.$emit('validated-fields', this.valuesObject);
    },
    setValue(value) {
      for (let i = 0; i < this.options.length; i += 1) {
        this.options[i].selected = `${this.options[i].value}` === `${value}`;
      }
    },
    setDefaultValue(list, value) {
      const newList = [];
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i += 1) {
          if (`${list[i].value}` === `${value}`) {
            newList.push(Object.assign({}, list[i], { selected: true }));
          } else {
            newList.push(Object.assign({}, list[i], { selected: false }));
          }
        }
      }
      return newList;
    },
    onInput() {
      this.$emit('input', this.valuesObject);
    },
    onSelect(value) {
      this.value = value;
      this.errorMsg = '';
      this.onInput();
    },
    formatOptions() {
      this.formattedOptions = [];
      if (this.includeDefault === true) {
        this.formattedOptions.push({
          value: '',
          text: 'Please select...',
          selected: this.default === '',
        });
      }
      for (let i = 0; i < this.options.length; i += 1) {
        if (typeof this.options[i] === 'string' || this.options[i] instanceof String) {
          this.formattedOptions.push({
            value: this.options[i],
            text: this.options[i],
            selected: `${this.options[i]}` === `${this.default}`,
          });
        } else {
          const option = this.options[i];
          option.selected = `${option.value}` === `${this.default}`;
          this.formattedOptions.push(option);
        }
      }

    },
  },
};
</script>

<style lang="scss" scoped>

label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal;
  line-height: 24px;
}

.first {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 58%;
  }
  margin-right: 10px;
}

.second {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 40%;
  }
}

.half {
  display: inline-block;
  width: 50%;
}

.half.first {
  width: 48%;
  margin-right: 5px;
}

</style>
